import angular from 'angular';
import ApplyTaxCertificateModalComponent from './applyTaxCertificate.modal.component';
export default angular.module('invision.customercare.applyTaxCertificateModal', []).component('applyTaxCertificateModal', ApplyTaxCertificateModalComponent).name;